<template>
    <div class="customcard">
        <div v-if="user_notfound">
            <h4 class="text-danger">User Not Found</h4>
        </div>
        <div v-if="user!==null">
            <div class="row">
        <div class="col-6 table-responsive">
            <table class="table">
            <thead class="bg-secondary">
                <tr>
                    <th scope="col">Property</th>
                    <th scope="col">Value</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th scope="row">Name</th>
                    <td>{{user.name}}</td>
                </tr>
                <tr>
                    <th scope="row">Phone</th>
                    <td>{{user.phone}}</td>
                </tr>
                <tr>
                    <th scope="row">Roles</th>
                    <td>
                        <div v-for="role in roles" class="mx-1 badge badge-warning">
                            {{role}}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th scope="row">Email</th>
                    <td>{{user.email}}</td>
                </tr>
                <tr>
                    <th scope="row">Level</th>
                    <td>{{user.level}}</td>
                </tr>
                <tr>
                  <th scope="row">Refers</th>
                  <td>{{user.refers}}</td>
                </tr>
                <tr>
                  <th scope="row">Friends</th>
                  <td>{{user.friends}}</td>
                </tr>
                <tr>
                  <th scope="row">Games</th>
                  <td>{{user.games}}</td>
                </tr>
                <tr>
                  <th scope="row">Challenges</th>
                  <td>{{user.challenges}}</td>
                </tr>
                <tr>
                  <th scope="row">Tournaments</th>
                  <td>{{user.tournaments}}</td>
                </tr>
                <tr>
                  <th scope="row">Correct Answers</th>
                  <td>{{user.correct}}</td>
                </tr>
                <tr>
                  <th scope="row">Incorrect Answers</th>
                  <td>{{user.incorrect}}</td>
                </tr>
                <tr>
                  <th scope="row">Spins</th>
                  <td>{{user.spins}}</td>
                </tr>
                <tr>
                    <th scope="row">Coins</th>
                    <td>{{user.wallet.coins}}</td>
                </tr>
                <tr>
                  <th scope="row">Gems</th>
                  <td>{{user.wallet.gems}}</td>
                </tr>
                <tr>
                  <th scope="row">Money Spent</th>
                  <td>{{user.wallet.money}}</td>
                </tr>
            </tbody>
            </table>
        </div>
        <div class="col-6">
            <div class="card w-50">
                <img :src="user.image_url" style="width:100px" class="center-div">
            </div>
        </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
    name: 'UserShow',
    data() {
        return {
            user: null,
            roles: [],
            user_notfound: false,
        }
    },
    created() {
        const user_id = this.$route.params.id;
        axios.get(`${ADMIN_URL}/users/${user_id}`)
            .then(response => {
                //console.log('Response  ', response)
                this.user = response.data;
                this.roles = this.user.roles;
            }).catch(error => {
                //console.log('Error. .. .', error.response);
                const errResponse = error.response;
                if (errResponse.status === 404) {
                    this.user_notfound = true;
                }
            })
    }
}
</script>

<style>

</style>
